import { FC, PropsWithChildren, useLayoutEffect, useState } from 'react';
import { Router } from 'react-router-dom';
import type { BrowserHistory } from 'history';
import { basename } from 'utils/basename';

const AppRouter: FC<PropsWithChildren<{ history: BrowserHistory }>> = ({
  history,
  ...props
}) => {
  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => history.listen(setState), []);

  return (
    <Router
      {...props}
      basename={basename}
      location={state.location}
      navigationType={state.action}
      navigator={history}
    />
  );
};

export default AppRouter;
